import React, { FC } from 'react';

export const DownArrowIcon: FC<any> = props => (
  <svg {...props} height="10" viewBox="0 0 17 10" width="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M258,489l-6.5,7.065L245,489"
      fill="none"
      stroke="var(--primary)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      transform="translate(-242.881 -486.88)"
    />
  </svg>
);
